<template>
    <div class="dib mb30 vat" :style="{width: (full ? 100 : (half ? 50 : width)) + '%'}" :class="{mr4: !half}">
        <p v-if="title" class="fs18 fw500" style="margin-bottom: 10px;">{{title}}</p>
        <p :class="$style.wrapper" :isSmall="isSmall" class="dflex">
            <span style="border-right: 1px solid rgb(185,185,185); padding: 0 8px;" class="dib" v-if="this.$slots.default"><slot></slot></span>
            <input type="text" class="f1" style="padding-left: 4px;" v-model="currentValue" :placeholder="placeholder">
        </p>
    </div>
</template>
<script>
export default {
    name: 'uinput',
    props: {
        title: { type: String, defualt: null},
        width: { type: Number, default: 45 },
        value: { type: String, default: "" },
        isSmall: { type: Boolean, default: false},
        half: {type: Boolean, default: false}, //占满半个
        full: {type: Boolean, default: false}, //占满整行
        placeholder: {type: String, default: ""},
    },
    data() {
        return {
            currentValue: this.value,
        }
    },
    watch: {
        value() {
            this.currentValue = this.value;
        },
        currentValue() {
            this.$emit("update:value", this.currentValue);
            this.$emit("input", this.currentValue);
        },
    }
}
</script>
<style module>
.wrapper {
    border: 1px solid #f3b707e6;
    line-height: 2;
    padding: 4px 4px;
}
.wrapper[isSmall] {
    padding: 0px;
}
</style>
